
import React from 'react';
import { QuestionTemplate } from '@/types/feedback';
import { UseFormReturn } from 'react-hook-form';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';

export type QuestionFieldsProps = {
  questions: QuestionTemplate[];
  form: UseFormReturn<any>;
  isDisabled?: boolean;
};

export const QuestionFields: React.FC<QuestionFieldsProps> = ({ 
  questions, 
  form, 
  isDisabled = false 
}) => {
  return (
    <div className="space-y-6">
      {questions.map((question) => (
        <FormField
          key={question.id}
          control={form.control}
          name={question.id}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{question.label}</FormLabel>
              <FormControl>
                {question.type === 'textarea' ? (
                  <Textarea 
                    placeholder={question.placeholder} 
                    disabled={isDisabled}
                    {...field} 
                  />
                ) : (
                  <div className="flex items-center space-x-2">
                    {[1, 2, 3, 4, 5].map((rating) => (
                      <Button
                        key={rating}
                        type="button"
                        variant={field.value === rating ? "default" : "outline"}
                        className="h-10 w-10 p-0"
                        disabled={isDisabled}
                        onClick={() => field.onChange(rating)}
                      >
                        {rating}
                      </Button>
                    ))}
                  </div>
                )}
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      ))}
    </div>
  );
};
